// extracted by mini-css-extract-plugin
export default {"wrapper":"Delivery_wrapper__Vi43l","header":"Delivery_header__5T2sU","goBack":"Delivery_goBack__NZsaZ","container":"Delivery_container__z66kH"};